module.exports = __webpack_public_path__ + "img/sonnenkopf.c23b78fd.jpg";